import React, { useContext } from 'react'
import SearchUsers from '../components/SearchUsers'
import { LoginContext } from '../service/context'

export default function AddContestant() {

  return (

    <>
     <SearchUsers />
    </>
  )
}
